var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4h24v24H4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10 7h13v17H10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7zm9.339 8.078c-.876 0-1.405.245-1.405.889 0 .702.91 1.011 2.04 1.395 1.841.623 4.265 1.444 4.276 4.49 0 2.95-2.364 4.648-5.805 4.648a11.493 11.493 0 0 1-4.514-.939v-3.924c1.39.759 3.143 1.32 4.516 1.32.925 0 1.587-.248 1.587-1.007 0-.776-.987-1.132-2.18-1.561-1.815-.654-4.104-1.479-4.104-4.224 0-2.918 2.232-4.665 5.589-4.665a10.935 10.935 0 0 1 4.101.758v3.874c-1.257-.675-2.844-1.054-4.101-1.054z",
    fill: "#821BB8",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComplete);
export default __webpack_public_path__ + "static/media/icon-complete.f526225df04aad9f6f55346595413d4a.svg";
export { ForwardRef as ReactComponent };